import {ID_CARD_VALID_TIME_SHORT} from "../config/IdCardValidTimeType";
import {OTHER_BANK_ID, selectedBankId} from "../config/bankAccountType";
import {ContactorTypeDict, WeChatOrganizationTypeDict} from "../config/MerchantType";
import ApiServices, {WX_SUB_MCH_APPLY} from "../config/ApiServices";
import api from "../utils/api";

const ID_CARD_TYPE = "IDENTIFICATION_TYPE_MAINLAND_IDCARD";

export class SubmitSubMchMaterialEvent {
    params = null;

    constructor (params) {
        this.params = params;
    }

    static getEventName () {
        return 'SubmitSubMchMaterialEvent';
    }
}

export class SubmitSubMchMaterialEventListener {
    async handle (event) {
        let materials = event.params;
        switch (materials.organizationType) {
            case WeChatOrganizationTypeDict.MICRO_SUB_MERCHANT:
                materials = this.microSubMerchantMaterialsTransformer(materials);
                break;
            case WeChatOrganizationTypeDict.SELF_EMPLOYMENT_MERCHANT:
                materials = this.selfEmploymentMerchantMaterialsTransformer(materials);
                break;
            case WeChatOrganizationTypeDict.ENTERPRISE_BUSINESS:
                materials = this.enterpriseBusinessMerchantTransformer(materials);
                break;
        }
        let res = await api(ApiServices[WX_SUB_MCH_APPLY]['apiName'], materials);
        if (res['status']) {
            event['success']();
        } else {
            event['failed']();
        }
    }

    microSubMerchantMaterialsTransformer (materials) {
        let isOtherBank = selectedBankId(materials.openAccountBank) === OTHER_BANK_ID;
        return {
            "organization_type": materials.organizationType + '',
            "owner": true,
            "id_holder_type": "LEGAL",
            "id_doc_type": ID_CARD_TYPE,
            "id_card_info": {
                "id_card_copy": materials.ownerIdCardFrontPhoto,
                "id_card_national": materials.ownerIdCardBackPhoto,
                "id_card_name": materials.ownerRealName,
                "id_card_number": materials.ownerIdCardNumber + '',
                "id_card_valid_time_begin": materials.ownerIdCardValidTimeBegin,
                "id_card_valid_time": materials.ownerIdCardValidation === ID_CARD_VALID_TIME_SHORT ? materials.ownerIdCardValidTimeEnd : "长期",
            },
            "account_info": {
                "bank_account_type": materials.bindBankAccountType + '',
                "account_bank": !isOtherBank ? materials.openAccountBank : '其他银行',
                "account_name": materials.openAccountName,
                "bank_name": isOtherBank ? materials.openAccountBank : '',
                "account_number": materials.bankAccountNumber + '',
                "bank_address_code": materials.bankAddressCodes[2] + '',
            },
            "contact_info": {
                "contact_type": ContactorTypeDict.CORPORATION + '',
                "contact_name": materials.ownerRealName,
                "contact_id_card_number": materials.ownerIdCardNumber + '',
                "mobile_phone": materials.contactorMobilePhoneNumber + '',
                "contact_email": materials.contactorEmail
            },
            "sales_scene_info": {
                "store_name": materials.merchantShortName,
                "store_url": "https://admin.cili-app.com/merchant/",
            },
            "merchant_shortname": materials.merchantShortName,
        };
    }

    selfEmploymentMerchantMaterialsTransformer (materials) {
        let result = this.microSubMerchantMaterialsTransformer(materials);
        result['owner'] = materials.benefitIsSelf;
        if (materials.contactorType === ContactorTypeDict.TRUSTIER) {
            result['contact_info'] = {
                "contact_type": materials.contactorType + '',
                "contact_name": materials.contactorRealName,
                "contact_id_doc_type": ID_CARD_TYPE,
                "contact_id_card_number": materials.contactorIdCardNumber + '',
                "contact_id_doc_copy": materials.contactorIdCardFrontPhoto,
                "contact_id_doc_copy_back": materials.contactorIdCardBackPhoto,
                "contact_id_doc_period_begin": materials.contactorIdCardValidTimeBegin,
                "contact_id_doc_period_end": materials.contactorIdCardValidation === ID_CARD_VALID_TIME_SHORT ? materials.contactorIdCardValidTimeEnd : "长期",
                "business_authorization_letter": materials.contactorAgentLicensePhoto,
                "mobile_phone": materials.contactorMobilePhoneNumber + '',
                "contact_email": materials.contactorEmail
            };
        }
        if (!materials.benefitIsSelf) {
            result['ubo_info_list'] = materials.benefitPersonList;
        }
        result['business_license_info'] = {
            "business_license_copy": materials.businessLicensePhoto,
            "business_license_number": materials.businessLicenseNumber + '',
            "merchant_name": materials.companyName,
            "legal_person": materials.ownerRealName
        };
        return result;
    }

    enterpriseBusinessMerchantTransformer (materials) {
        let result = this.selfEmploymentMerchantMaterialsTransformer(materials);
        result['id_card_info']['id_card_address'] = materials.ownerIdCardAddress;
        return result;
    }
}